import React from 'react'
import SizeSelect, { Size } from './SizeSelect'
import MultiSelect from './MultiSelect'
import { without } from 'lodash'

interface MultiSizeSelectProps {
  values: Size[]
  onChange: (items: Size[]) => void
}

export default function MultiSizeSelect({ values, onChange }: MultiSizeSelectProps) {
  const buttonProps = {
    minimal: true,
    iconName: 'plus',
    blue: true,
  }
  return (
    <MultiSelect
      title="Sizes"
      values={values.map((v) => (
        <span key={v}>{v}</span>
      ))}
      select={
        <SizeSelect
          multi
          btnText="Add"
          value={null}
          itemDisabled={(item) => values.includes(item)}
          onChange={(size) =>
            onChange(values.includes(size) ? without(values, size) : [...values, size])
          }
          {...{ buttonProps }}
        />
      }
      onRemove={(v) => onChange(values.filter((av) => av !== v))}
    />
  )
}
